import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { CookieListenerDirective, getCookiePreferences, StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';
import { DynamicHooksComponent } from 'ngx-dynamic-hooks';

@Component({
  selector: 'app-markdown',
  imports: [ CookieListenerDirective,
    DynamicHooksComponent,
    StripEmbedPipe,
    ResizeHtmlImagesPipe],
  templateUrl: './markdown.component.html',
  styleUrl: './markdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarkdownComponent {
  private store = inject(Store);
  cookiePreferences = this.store.selectSignal(getCookiePreferences);
  content = input<string>('');
  cssClasses = input<string>(''); 
}
